import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class RouteMapService {
  readonly locations = signal<unknown[]>([]);
  readonly sidebarVisible = signal(false);

  setLocations(locations: unknown[]): void {
    this.locations.set(locations);
  }

  toggleSidebar(): void {
    this.sidebarVisible.update(v => !v);
  }

  openSidebar(): void {
    this.sidebarVisible.set(true);
  }

  closeSidebar(): void {
    this.sidebarVisible.set(false);
  }

  clearLocations(): void {
    this.locations.set([]);
  }
}
